import React from "react";
import { Link } from "react-router-dom";
import { LegalLayout, LegalSection, LegalList } from "@/components/site/LegalLayout";

const ACCEPTABLE_USE = [
  "Do not use the site or assistant for unlawful, harmful, or abusive purposes.",
  "Do not attempt to disrupt, overload, reverse-engineer, or gain unauthorized access to the site or its systems.",
  "Do not submit content that infringes the rights of others.",
];

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="June 2026">
      <p className="text-[#5C6C80]">
        These Terms of Service (&ldquo;Terms&rdquo;) govern your use of the website and AI support
        assistant of Process Safety &amp; Integrity Engineering Consultants (&ldquo;PSIEC&rdquo;).
        By accessing or using this site, you agree to these Terms.
      </p>

      <LegalSection heading="1. Informational Purpose Only">
        <p>
          The content on this website, including all service descriptions and AI assistant
          responses, is provided for general informational purposes only. It does not constitute
          professional engineering, safety, legal, financial, or medical advice, and does not
          create a consultant–client relationship. Formal engagements are governed by a separate
          written agreement.
        </p>
      </LegalSection>

      <LegalSection heading="2. AI Assistant Disclaimer">
        <p>
          Our AI assistant (&ldquo;Emmy&rdquo;) is an automated tool that can produce inaccurate,
          incomplete, or outdated information. You should independently verify any information
          before relying on it, and always consult a qualified professional for process safety
          decisions. Do not submit confidential, proprietary, or sensitive personal information
          to the assistant.
        </p>
      </LegalSection>

      <LegalSection heading="3. Health & Safety Notice">
        <p>
          The AI assistant is not a crisis, medical, or mental-health service. If you or someone
          else may be in danger or experiencing a mental-health crisis, contact your local
          emergency services immediately. In the U.S., you can call or text{" "}
          <strong className="text-[#04162E]">988</strong> (Suicide &amp; Crisis Lifeline) or dial{" "}
          <strong className="text-[#04162E]">911</strong>.
        </p>
      </LegalSection>

      <LegalSection heading="4. Acceptable Use">
        <LegalList items={ACCEPTABLE_USE} />
      </LegalSection>

      <LegalSection heading="5. Intellectual Property">
        <p>
          All content, branding, and materials on this site are owned by PSIEC or its licensors
          and may not be copied or reused without permission.
        </p>
      </LegalSection>

      <LegalSection heading="6. No Warranties">
        <p>
          The site and assistant are provided &ldquo;as is&rdquo; and &ldquo;as available&rdquo;
          without warranties of any kind, whether express or implied, including fitness for a
          particular purpose and non-infringement.
        </p>
      </LegalSection>

      <LegalSection heading="7. Limitation of Liability">
        <p>
          To the maximum extent permitted by law, PSIEC shall not be liable for any indirect,
          incidental, consequential, or special damages arising from your use of the site or
          assistant, including reliance on any AI-generated content.
        </p>
      </LegalSection>

      <LegalSection heading="8. Changes to These Terms">
        <p>
          We may update these Terms from time to time. Continued use of the site after changes
          take effect constitutes acceptance of the revised Terms.
        </p>
      </LegalSection>

      <LegalSection heading="9. Contact">
        <p>
          Questions about these Terms? Reach us through our{" "}
          <Link to="/#contact" className="text-[#0B6B44] underline hover:text-[#04162E]">
            contact form
          </Link>
          . See also our{" "}
          <Link to="/privacy" className="text-[#0B6B44] underline hover:text-[#04162E]">
            Privacy Policy
          </Link>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
